import { render, staticRenderFns } from "./TableCalculate.vue?vue&type=template&id=b8084fc6&scoped=true&"
import script from "./TableCalculate.vue?vue&type=script&lang=js&"
export * from "./TableCalculate.vue?vue&type=script&lang=js&"
import style0 from "./TableCalculate.vue?vue&type=style&index=0&id=b8084fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8084fc6",
  null
  
)

export default component.exports